
/**
 * Handles single data entry export dialog
 */
namespace appn.dialog.singleEntryExport {

    export function init() {
        onSelectedTemplateChanged();
        addEvents();
    }

    function addEvents() {
        $('.singleEntryExportLink').off().on('click', function(e) {
            e.preventDefault();

            // Update the selected entry value
            const entryId = $(this).data('entryid');
            const $singleEntryExportForm = $('#singleEntryExportForm');
            const $singleEntryExportDialog = $('#singleEntryExportDialog');

            // Update the selected entry Id
            $singleEntryExportForm.find('#selectedEntryId').remove();
            $singleEntryExportForm.append(`<input type="hidden" id="selectedEntryId" name="Id" value="${entryId}" />`);

            // Populate the selected template dropdown if the exportLink has a data-templatefiles
            injectTemplateData($(this));

            // Show hide controls based on whether there are templates or not
            if ($singleEntryExportDialog.find('#SelectedTemplate option').length === 1)
                $('.hideifnotemplate').hide();
            else
                $('.hideifnotemplate').show();

            // Show dialog
            $singleEntryExportDialog.modal('show');

            // Wire up billing upgrade dialog
            appn.dialog.showBillUpgradeOnClick(function() {
                $('input[name="EmbedImageLinks"]').prop('checked', false);
            });

            select.init();
        });

        $('#singleEntryExportForm').off().on('submit', function(e) {
            $('#singleEntryExportForm input[name="exportGenericPdf"]').remove();

            // Determine which generic template format to output
            const currentOption = $('#singleEntryExportForm').find('#SelectedTemplate option:selected');
            const dataAttr = $(currentOption).data();
            if (dataAttr.hasOwnProperty('generic')) {
                $('#singleEntryExportForm').append(`<input type="hidden" id="exportGenericPdf" name="exportGenericPdf" value="true" />`);
                $('input[name="SelectedFileName"]').val(currentOption.val() as string);
            }

            appn.ajax.post({
                url: $(this).attr('action') as string,
                data: $('#singleEntryExportForm').serialize(),
                always: function() {
                    appn.notifications.updateNotificationTotal();
                    appn.ui.showExportConfirmation('Form Entry');
                    appn.dialog.hideLoading();
                }
            });

            $('#singleEntryExportDialog').modal('hide');

            return false;
        });
    }

    function onSelectedTemplateChanged() {
        $('#singleEntryExportDialog #SelectedTemplate').off().on('change', function() {
            const $selectedOption = $('option:selected', this);
            const attachmentNames = $selectedOption.data('attachmentnames');
            toggleAttachmentNamesSelect(attachmentNames, $('.form-control-filename'));
        });
    }

    function injectTemplateData($exportLink: JQuery<HTMLElement>) {
        const templateFilesToInject = $exportLink.data('templatefiles');
        if (!templateFilesToInject)
            return;

        const $exportEntryDialog = $('#singleEntryExportDialog');
        let selectHtml = '<select class="form-control" id="SelectedTemplate" name="SelectedTemplate">';
        let hasAlreadyAddedGroup = false;
        let addedGroupName = '';
        $(templateFilesToInject).each(function(i, file) {
            if ((file.Group && file.Group.Name) && (!hasAlreadyAddedGroup || file.Group.Name !== addedGroupName)) {
                selectHtml += `<optgroup label="${file.Group.Name}"></optgroup>`;
                hasAlreadyAddedGroup = true;
                addedGroupName = file.Group.Name;
            }

            // file.DataValue is set like an array to be used by onSelectedTemplateChanged so it has a value like ["TemplateName"]
            // The " in the file name means that we need use ' as the string delimiter.
            selectHtml += `<option value="${file.Value}" ${file.DataTag}='${file.DataValue}'>${file.Text}</option>`;
        });
        selectHtml += '</select>';
        const $injectTemplateFileDropdown = $exportEntryDialog.find('.injectTemplateFileDropdown');
        $injectTemplateFileDropdown.html(selectHtml);
        onSelectedTemplateChanged();
    }
}

/**
 * Handles bulk data entry export dialog
 */
namespace appn.dialog.bulkEntryExport {

    /**
     * Prepares the bulk export page when "Manage" is clicked on multiple entries
     */
    export function init() {
        // Check if the dropdowns exist and then populate them
        const types: Array<string> = ['bulk-export-pdf', 'bulk-export-word', 'bulk-export-excel'];

        types.forEach(function(type, index) {
            // Add events for the bulk exports
            const template = $(`.card-planejane.${type} #Template.${type}`);
            toggleAttachmentNamesSelect($('option:selected', template).data('attachmentnames'), $(`.form-control-filename-bulk[data-target='${type}']`), type);

            template.on('change', function() {
                toggleAttachmentNamesSelect($('option:selected', this).data('attachmentnames'), $(`.form-control-filename-bulk[data-target='${type}']`), type);
            });
        });
    }

    /**
     * This sets the selected values into the correct hidden values for the export jobs to take from
     */
    export function bulkExportSetValues(type: string) {
        const selectedFileName = $('input[name="SelectedFileName"]');
        const selectedTemplate = $('input[name="SelectedTemplate"]');
        let format = emptyString;

        switch (type) {
            case 'BulkPDF':
                format = 'bulk-export-pdf';
                break;
            case 'BulkWord':
                format = 'bulk-export-word';
                break;
            case 'BulkExcel':
                format = 'bulk-export-excel';
                break;
        }

        const templateString = $(`.card-planejane.${format} select.${format}#Template`).val();
        const filenameString = $(`.card-planejane.${format} select.${format}#FileName`).val();

        if (templateString)
            selectedTemplate.val(templateString as string);

        if (filenameString)
            selectedFileName.val(filenameString as string);

        // Determine which generic template format to output
        $('#manageForm input[name="exportGenericPdf"]').remove();
        const currentOption = $(`.card-planejane.${format} select.${format}#Template option:selected`);
        const dataAttr = $(currentOption).data();
        if (dataAttr.hasOwnProperty('generic') && format === 'bulk-export-pdf')
            $('#manageForm').append(`<input type="hidden" id="exportGenericPdf" name="exportGenericPdf" value="true" />`);
    }
}
